
import Vue from 'vue'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import PageLayout from '@/layouts/Page.vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import ProspectFastForm from '@/components/forms/ProspectFastForm.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'

const prospectModule = namespace('prospect')

@Component({
  components: {
    PageLayout,
    PageMenuLayout,
    BaseFormContainer,
    ProspectFastForm
  }
})
export default class ProspectCreateFast extends Vue {
  @prospectModule.Action('createProspectFastAction') createProspectFast: any

  onSubmit(data: any) {
    this.createProspectFast(data).then(async (data: any) => {
      this.$router.push({name: 'prospectDetail', params: {id: data.ID}})
    })
  }

  onCancel() {
    this.$router.go(-1)
  }
}
